module.exports = new __parcel__URL__("roadmap-light.937dbfb6.svg").toString();